import React, { useState } from 'react';
import { Discount, DiscountResponse } from '../models/APIModels';
import { axiosKK } from '../services/networkRequest';
import SubmitButton from './SubmitButton';
import Label from './Label';
import Error from './Error';

interface DiscountCodeProps {
  successfulDiscount: (discount: Discount) => void;
}

function DiscountComponent(props: DiscountCodeProps): JSX.Element {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [discountCode, setDiscountCode] = useState<string>('');
  const [error, setError] = useState<string>('');

  return (
    <div className="discount-info">
      <Label htmlFor="discount" className="discount-label">
        Discount
      </Label>
      <div className="input-and-btn">
        <input
          id="discount"
          type="text"
          placeholder="Enter Discount Code"
          value={discountCode}
          onChange={(event) => {
            setError('');
            setDiscountCode(event.target.value.toUpperCase());
          }}
        />
        <SubmitButton
          type="button"
          isSubmitting={submitting}
          onClick={(event) => {
            event.preventDefault();
            setSubmitting(true);
            setError('');

            axiosKK
              .get<DiscountResponse>(`/discountCode/${discountCode}`)
              .then(({ data }) => {
                props.successfulDiscount(data?.discount);
              })
              .catch((err) => {
                console.error(err);
                const status = err?.response?.status;
                if (status === 404) {
                  setError('Discount code not found or is no longer active.');
                } else {
                  setError('Something went wrong. Please try again.');
                }
              })
              .finally(() => {
                setSubmitting(false);
              });
          }}
        >
          Submit
        </SubmitButton>
      </div>
      <Error error={error} touched={!!error} removeBreak />
    </div>
  );
}

export default DiscountComponent;
